import { Component, OnInit, Renderer2 } from '@angular/core';
import { JoinService } from 'apps/driver-dashboardfe/src/app/core/services/join/join.service';
import { ScriptService } from 'apps/driver-dashboardfe/src/app/core/services/script/script.service';
import { scripts } from 'apps/driver-dashboardfe/src/app/shared/constants/script.constant';
import { environment } from 'apps/driver-dashboardfe/src/environments/environment';
import { resetUserToken } from '../../shared/utitlity-functions/utility-functions';

@Component({
    standalone: false,
    templateUrl: './do-not-contact.component.html',
    styleUrls: ['./do-not-contact.component.scss'],
})
export class DoNotContactComponent implements OnInit {
    fbPixelUs: any;
    fbPixelUsNoScript: any;
    fbPixelCanada: any;
    fbPixelCanadaNoScript: any;
    firstName: any;

    constructor(
        private renderer: Renderer2,
        private scriptService: ScriptService,
        private joinService: JoinService
    ) {}

    ngOnInit(): void {
        resetUserToken();
        if (environment.production && environment.shouldAddPixel) {
            this.fbPixelUs = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-us']
            );
            this.fbPixelUsNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-us']
            );
            this.fbPixelCanada = this.scriptService.loadJs(
                this.renderer,
                scripts['fb-canada']
            );
            this.fbPixelCanadaNoScript = this.scriptService.loadNoScriptImg(
                this.renderer,
                scripts['fb-image-canada']
            );
        }
        this.joinService.getUserData().subscribe((data: any) => {
            this.firstName = data?.first_name;
        });
    }
    ngOnDestroy(): void {
        if (environment.production && environment.shouldAddPixel) {
            this.scriptService.removeScript(this.renderer, this.fbPixelUs);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelUsNoScript
            );
            this.scriptService.removeScript(this.renderer, this.fbPixelCanada);
            this.scriptService.removeScript(
                this.renderer,
                this.fbPixelCanadaNoScript
            );
        }
    }
}
